import React, { useState, useEffect } from 'react';
import { useAPI } from '../../ApiCalls/useAPI';
import { Card, Button } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';

export default function Notifications() {
    const [data, setData] = useState([]);
    const [i, seti] = useState(4);
    const { getNotifications } = useAPI();

    useEffect(() => {
        getNotifications()
            .then((response) => {
                // console.log(response, 'notifications');
                setData(response);
            })
            .catch((error) => console.error(error));
    }, []);

    if (data.length === 0) {
        return (
            <div className="container">
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Notifications</div>
                </div>

                <Card className="mt-4 p-4 text-center">NO NOTIFICATIONS FOUND</Card>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Notifications</div>
            </div>
            <div id="notifications_content">
                {data.slice(0, i).map((item) => {
                    return (
                        <Card
                            title={item.title}
                            body={
                                <div>
                                    <div
                                        className="mt-3 mb-3"
                                        style={{
                                            display: 'flex',
                                            fontWeight: '600'
                                        }}
                                    >
                                        <div className="mr-6">
                                            Date : {item.date}
                                        </div>
                                        <div>{item.days}</div>
                                    </div>
                                    <div>
                                        <div>{item.description}</div>
                                    </div>
                                </div>
                            }
                        />
                    );
                })}
            </div>
            <div className="mt-4">
                <div className="mb-4" style={{ float: 'left' }}>
                    <Button
                        disabled={i === data.length || data.length <= 4}
                        onClick={() => seti(i + 3)}
                        color="primary"
                    >
                        View More
                    </Button>
                </div>
                <div className="mb-4" style={{ float: 'right' }}>
                    <Button
                        disabled={i < 5}
                        onClick={() => seti(i - 3)}
                        color="primary"
                    >
                        View Less
                    </Button>
                </div>
            </div>
        </div>
    );
}
